<div class="container-fluid mb-5 px-3">
    <div class="mt-3 d-flex justify-content-between">
        <div class="font-weight-bold">
            <h1>
                @if (selectedOrganizationName) {
                    <span>{{ selectedOrganizationName }}</span>
                }
                Screening Report
            </h1>
        </div>
    </div>
    <mat-card class="mt-3 pb-5" style="min-height:500px;">
        <div class="px-3 pt-3">
            <mat-button-toggle-group [value]="queue" (change)="setQueue($event.value)" aria-label="Queue">
                <mat-button-toggle [value]="queues.NEEDS_REVIEW">Needs review</mat-button-toggle>
                <mat-button-toggle [value]="queues.REVIEWED">Reviewed</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="row g-0">
            <div class="col-lg-6">
                <div class="px-3 pt-3">
                    <div class="row align-items-center">
                        <!-- The table column is half the page, so col-lg-6 here matches the col-lg-3 search bar on other tables. -->
                        <div class="col-lg-6 col-12 d-flex flex-row align-items-center">
                            <mat-icon class="filter-icon">filter_list</mat-icon>
                            @for (filterDefinition of filterDefinitions; track filterDefinition.id) {
                                <app-data-table-filter class="filter" [filterDefinition]="filterDefinition" [disable]="loading$">
                                </app-data-table-filter>
                            }
                        </div>
                        <div class="col-lg-6 col-12 my-2">
                            <mat-form-field appearance="outline" class="search-bar">
                                <mat-label>
                                    <mat-icon class="search-icon">search</mat-icon>
                                    <span>Search</span>
                                </mat-label>
                                <input matInput data-test="search-input" [(ngModel)]="searchKeyword"
                                    (keyup.enter)="onSearch()" (keyup.backspace)="onSearchBackspace()">
                                @if (searchKeyword) {
                                    <button type="button" matSuffix mat-icon-button aria-label="Clear" data-test="clear-search"
                                        (click)="clearSearch()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center pt-2" data-test="filter-pills">
                        @for (filterPill of filterPills | keyvalue; track filterPill.key) {
                            <app-data-table-filter-pill [filterState]="filterPill.value" [disable]="loading$"
                                (closeClickEvent)="onFilterPillClose($event)">
                            </app-data-table-filter-pill>
                        }
                    </div>
                </div>
                @if (loading) {
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
                <div class="table-responsive">
                    <table mat-table [dataSource]="rows" matSort [matSortActive]="sortColumn"
                        [matSortDirection]="sortDirection === 'ASC' ? 'asc' : 'desc'"
                        matSortDisableClear (matSortChange)="onSort($event)" class="table" [class.table-loading]="loading">
                        <ng-container matColumnDef="guest">
                            <th mat-header-cell *matHeaderCellDef> Guest </th>
                            <td mat-cell *matCellDef="let row"> {{ row.firstName }} {{ row.lastName }} </td>
                        </ng-container>
                        <ng-container matColumnDef="organization">
                            <th mat-header-cell *matHeaderCellDef> Organization </th>
                            <td mat-cell *matCellDef="let row"> {{ row.organizationName }} </td>
                        </ng-container>
                        <ng-container matColumnDef="dates">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Reservation Dates </th>
                            <td mat-cell *matCellDef="let row"> {{ reservationDates(row) }} </td>
                        </ng-container>
                        <ng-container matColumnDef="completed">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef
                                matTooltip="When the guest's screening finished and the result came back as Consider"> Screening Completed </th>
                            <td mat-cell *matCellDef="let row"> {{ formatDate(row.dateCompleted, true) }} </td>
                        </ng-container>
                        <ng-container matColumnDef="reviewedAt">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Reviewed </th>
                            <td mat-cell *matCellDef="let row"> {{ formatDate(row.reviewedAt, true) }} </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: tableColumns;" class="report-row"
                            [class.selected-row]="row.screeningId === selectedRow?.screeningId"
                            [attr.aria-selected]="row.screeningId === selectedRow?.screeningId" (click)="onRowClick(row)"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell empty-state" [attr.colspan]="tableColumns.length">
                                @if (!loading) {
                                    @if (queue === queues.NEEDS_REVIEW) {
                                        Nothing to review — all Consider screenings have been handled.
                                    } @else {
                                        No reviewed screenings match these filters.
                                    }
                                }
                            </td>
                        </tr>
                    </table>
                </div>
                <mat-paginator (page)="onPage($event)" [pageSizeOptions]="pageSizeOptions" [length]="totalRecords"
                    [pageIndex]="pageIndex" [pageSize]="pageSize" aria-label="Select page" showFirstLastButtons>
                </mat-paginator>
            </div>
            <div class="col-lg-6">
                <div class="panel-container">
                    <app-screening-review-panel [row]="selectedRow" [queue]="queue" [pendingAction]="pendingAction"
                        (keepAsConsider)="onKeepAsConsider($event)" (markAsPassed)="onMarkAsPassed($event)" (returnToQueue)="onReturnToQueue($event)">
                    </app-screening-review-panel>
                </div>
            </div>
        </div>
    </mat-card>
</div>
